import React from 'react';
export const TestimonialsSection = () => {
  const testimonials = [{
    name: 'Joanna, 43 lata',
    location: 'Warszawa',
    text: 'Po 18 latach małżeństwa myślałam, że namiętność to już tylko wspomnienie. Metoda Odwróconej Polarności zmieniła wszystko. Mój mąż patrzy na mnie jak kiedyś - z pożądaniem w oczach.'
  }, {
    name: 'Agnieszka, 47 lat',
    location: 'Poznań',
    text: 'Byłam na skraju rozwodu. Mąż żył swoim życiem, ja swoim. Ten e-book był moją ostatnią deską ratunku. Po 6 tygodniach stosowania metody, znów czuję się kochana i pożądana.'
  }, {
    name: 'Katarzyna, 51 lat',
    location: 'Wrocław',
    text: 'Myślałam, że problem leży w moim wyglądzie - przytyłam, pojawiły się zmarszczki. Ale dzięki tej metodzie zrozumiałam, że to nie o to chodzi. Teraz mój mąż mówi, że jestem dla niego bardziej atrakcyjna niż kiedykolwiek.'
  }, {
    name: 'Małgorzata, 45 lat',
    location: 'Kraków',
    text: 'Już po pierwszym tygodniu zauważyłam zmianę - nie w nim, ale we mnie. A potem, jak za dotknięciem czarodziejskiej różdżki, on też zaczął się zmieniać. Teraz znów czuję motyle w brzuchu, gdy wraca do domu.'
  }];
  return <section className="w-full bg-white py-16 px-4 md:px-8 lg:px-16" data-id="element-186">
      <div className="max-w-6xl mx-auto" data-id="element-187">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-800 mb-6 text-center" data-id="element-188">
          Kobiety, które przerwały Błędne Koło
        </h2>
        <p className="text-lg text-gray-700 mb-12 text-center max-w-3xl mx-auto" data-id="element-189">
          Oto historie kobiet, które były dokładnie w Twojej sytuacji, zanim
          odkryły Metodę Odwróconej Polarności:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-190">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gradient-to-br from-[#faf7f2] to-[#f5f0e8] p-6 rounded-lg shadow-md" data-id="element-191">
              <p className="text-gray-700 italic mb-4" data-id="element-192">"{testimonial.text}"</p>
              <div className="flex items-center" data-id="element-193">
                <div className="bg-red-500 text-white w-10 h-10 rounded-full flex items-center justify-center font-bold" data-id="element-194">
                  {testimonial.name.charAt(0)}
                </div>
                <div className="ml-3" data-id="element-195">
                  <p className="font-bold text-gray-800" data-id="element-196">{testimonial.name}</p>
                  <p className="text-gray-600 text-sm" data-id="element-197">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};